import { render, staticRenderFns } from "./ProgramDetailArticles.vue?vue&type=template&id=85801490&scoped=true&"
import script from "./ProgramDetailArticles.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailArticles.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailArticles.vue?vue&type=style&index=0&id=85801490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85801490",
  null
  
)

export default component.exports